import { createRouter, createWebHistory } from "vue-router";

// 导入页面组件
import Home from "@/views/HomeView.vue";
import ProductList from "@/views/ProductList.vue";
import ProductDetail from "@/views/ProductDetail.vue";
import Contact from "@/views/Contact.vue";
import Login from "@/views/login/index.vue";
import Layout from "@/components/LayoutII.vue";
import Baseset from "@/views/BaseSet/index.vue";
const routes = [
  {
    path: "/",
    redirect: "/login", // 默认跳转到登录页
  },
  {
    path: "/login",
    name: "Login",

    component: Login,
  },
  {
    path: "/main",
    name: "Main",
    component: Layout,
    children: [
      {
        path: "/home",
        name: "Home",
        component: Home,
      },
      {
        path: "/contact",
        name: "Contact",
        component: Contact,
      },
      {
        path: "/products",
        name: "ProductList",
        component: ProductList,
      },
      {
        path: "/baseset",
        name: "Baseset",
        component: Baseset,
      },
    ],
  },

  {
    path: "/product/:id", // 动态路由，匹配产品ID
    name: "ProductDetail",
    component: ProductDetail,
    props: true, // 开启 props 传参，方便获取 id
  },

  // 404 页面（可选）
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  // 路由跳转后滚动到顶部
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
